module.exports = __webpack_public_path__ + "static/media/arrow.4d774978.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.svg
// module id = 269
// module chunks = 0